// FieldConfig.js

export class FieldConfig {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = "ReadWrite",
    //  PagePermission = 'disable'
    //  ,
    place = '', value = "") {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    // this.PagePermission = PagePermission;
    this.place = place;
    this.value = value;

  }

  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}




export const AddStockFields = [

  new FieldConfig("VendorId", "Supplier", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("SKU", "SKU", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("LotNumber", "Lot Number", "", 1, "inputselect", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("StockType", "Stock Type", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
  new FieldConfig("Branch", "Branch", "", 1, "dropdown", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelgold", "Unlabel Gold", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelsilver", "Unabel Silver", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabeldiamond", "Unlabel Diamond", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  // new FieldConfig("unlabelother", "Unlabel Other", "", 1, "text", "ReadWrite", "ReadWrite", "top"),
  //label
  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("CollectionId", "Collection", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PacketId", "Packet", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("BoxId", "Box", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("mainstone", "Select stones", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WeightCategory", "Weight Categories", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Quantity", "Quantity", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalWeight", "Total Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("GrossWt", "Gross Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("TotalStoneWeight", "Stone Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("NetWt", "Net Wt", "", 1, "inputdecimal", "ReadOnly", "ReadOnly", "middle"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingPerGram", "Making/Grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MakingFixedAmt", "Fixed Making", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("ClipWeight", "Clip Wt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("ClipQuantity", "Clip Qty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "middle"),
  
  new FieldConfig("ProductName", "Product Name", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "middle"),
  

  //loose diamonds
  new FieldConfig("DiamondShape", "Diamond shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondClarity", "Diamond Clarity", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondColour", "Diamond Colour", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSleve", "Diamond sleves", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondWeight", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSellRate", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondPieces", "D Pieces", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("images", "Totalweight", "", 1, "imagesbox", "ReadWrite", "ReadWrite", "middle"),
  // new FieldConfig("totalamount", "Totalamount", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondSettingType", "Diamond Setting", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondCertificate", "certificate", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("DiamondDescription", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  
  //unlabel gold
  new FieldConfig("FinePercent", "Fine", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("WastagePercent", "Wastage", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("FineWastage", "Fine+Wastage", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "middle"),

  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "Hidden", "middle"),
  
  new FieldConfig("importbtn", "Import", "", 1, "button", "ReadWrite", "ReadWrite", "middle"),
  
  //stones
  new FieldConfig("StoneName", "Diamond shape", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneColor", "Diamond Clarity", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneShape", "Diamond Colour", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSize", "Diamond Size", "", 1, "inputtext", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneWeight", "Diamond sleves", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StonePieces", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRatePiece", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneRateKarate", "Diamond sleves", "", 1, "inputselect", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneAmount", "Diamond weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneDescription", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneCertificate", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  new FieldConfig("StoneSettingType", "D SellRate", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "middle"),
  







  
  
  //grid


  new FieldConfig("VendorId", "Vendor", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("SKU", "SKU", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("ItemCode", "ItemCode", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("RFIDCode", "RFIDCode", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TIDNumber", "TidValue", "", 1, "inputtext", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("TotalWeight", "TotalWT", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PackingWeight", "Packing Weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  // new FieldConfig("TotalStoneWeight", "TStoneWT", "", 1, "read", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("CategoryId", "Category", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductId", "Product", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PurityId", "Purity", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DesignId", "Design", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("GrossWt", "Grosswt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneWeight", "StoneWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipWeight", "ClipWt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ClipQuantity", "ClipQty", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("NetWt", "Netwt", "", 1, "inputdecimal", "ReadWrite", "ReadOnly", "grid"),
  new FieldConfig("Size", "Size", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Pieces", "Pieces", "", 1, "inputnumber", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductTitle", "Producttitle", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ProductCode", "Product Code", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HUIDCode", "Huid", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("HallmarkAmount", "Hallmark", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalStoneAmount", "TotalSAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPerGram", "Making/grm", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingPercentage", "Making%", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MakingFixedAmt", "MakingFixedAmt", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("MakingFixedWastage", "MakingFixedWastage", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("MRP", "MRP", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("OtherWeight", "Other weight ", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("PouchWeight", "Pouch weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TagWeight", "Tag weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("FindingWeight", "Finding weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("LanyardWeight", "Lanyard weight", "", 1, "inputdecimal", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("OccassionName", "Occcassion", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Gender", "Gender", "", 1, "dropdown", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Status", "status", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("Featured", "Featured", "", 1, "inputtext", "ReadWrite", "ReadWrite", "grid"),
  // new FieldConfig("Metal", "Metal", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),


  new FieldConfig("DiamondShape", "D Shape", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondClarity", "D Clarity", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondColour", "D Colour", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCut", "D Cut", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSize", "Diamond Size", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSleve", "Diamond Sleves", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondWeight", "Diamond wt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellRate", "D Sell Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSettingType", "D SettingType", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondCertificate", "Diamond certificate", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondDescription", "D Description", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),



  new FieldConfig("DiamondName", "Diamond Name", "", 1, "text", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondAmount", "Diamond Amount", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPieces", "Diamond Pcs", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondPurchaseRate", "D Purchase Rate", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("DiamondPurchaseAmount", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DiamondSellAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondWeight", "D Purchase Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("TotalDiamondAmount", "D Sell Amt", "", 1, "number", "ReadWrite", "ReadWrite", "grid"),

  new FieldConfig("Stones", "Stones", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("DButton", "Diamonds", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("IButton", "Images", "", 1, "popup", "ReadWrite", "ReadWrite", "grid"),
  new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", "ReadWrite", "grid"),


];



